module.exports = __webpack_public_path__ + "static/media/12576254_1056264244394997_180181941_n.813094ab.jpg";